import clsx from 'clsx';
import { forwardRef } from 'react';

const accentRing = {
  amber: 'focus:ring-amber-500 focus:border-amber-500',
};

const Textarea = forwardRef(({ label, required, error, className, accent = 'amber', rows = 3, ...props }, ref) => {
  return (
    <div className="w-full">
      {label && (
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">
          {label}
          {required && <span className="text-red-500 ml-0.5">*</span>}
        </label>
      )}
      <textarea
        ref={ref}
        required={required}
        rows={rows}
        className={clsx(
          'block w-full rounded-lg border bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 placeholder-gray-400 dark:placeholder-gray-500 shadow-sm transition-colors resize-y',
          'focus:outline-none focus:ring-2',
          error
            ? 'border-red-400 dark:border-red-600 focus:ring-red-400'
            : ['border-gray-300 dark:border-gray-600', accentRing[accent]],
          'px-3 py-2.5 text-sm',
          className
        )}
        {...props}
      />
      {error && <p className="mt-1.5 text-xs text-red-600 dark:text-red-400">{error}</p>}
    </div>
  );
});

Textarea.displayName = 'Textarea';
export default Textarea;
